import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DmsInterceptStrategy } from './auth-shared/DmsInterceptStrategy';
import { EmptyInterceptStrategy } from './auth-shared/EmptyInterceptStrategy';
import { InterceptStrategy } from './auth-shared/InterceptStrategy';
import { MaestrosSyncInterceptStrategy } from './auth-shared/MaestrosSyncInterceptStrategy';
import { SumaxErpInterceptStrategy } from './auth-shared/SumaxErpInterceptStrategy';

@Injectable({ providedIn: 'root' })
export class InterceptorsStrategyService {
	strategies: InterceptStrategy[] = [
		this.dmsInterceptStrategy,
		this.emptyInterceptStrategy,
		this.maestrosInterceptStrategy,
		this.sumaxErpInterceptStrategy,
	];

	constructor(
		private dmsInterceptStrategy: DmsInterceptStrategy,
		private emptyInterceptStrategy: EmptyInterceptStrategy,
		private maestrosInterceptStrategy: MaestrosSyncInterceptStrategy,
		private sumaxErpInterceptStrategy: SumaxErpInterceptStrategy
	) {}

	resolveStrategy(req: HttpRequest<any>): InterceptStrategy | undefined {
		return this.strategies.find((s) => s.isIntercepted(req));
	}
}
